import {Inject, Injectable} from '@angular/core';
import {AngularFireDatabase} from 'angularfire2/database';
import {FirebaseApp} from 'angularfire2';
import {AuthService} from './auth.service';
import {Observable} from '../../../../node_modules/rxjs';
import * as firebase from 'firebase';
import {Client} from '../classes/client';
import {ClientInfo} from '../classes/client-info';
import * as moment from 'moment';
import {PmiExam} from '../classes/pmiExam';

@Injectable()
export class ClientService {
  private sdkDb: any;
  private userId: string = null;
  private userType: string = null;
  constructor(private db: AngularFireDatabase, @Inject(FirebaseApp) fb: FirebaseApp, private authService: AuthService) {
    this.sdkDb = fb.database();
    this.authService.getCurrentUser().subscribe(user => {
      if  (user) {
        this.userId = user.uid;
      } else {
        user = null;
      }
    });
    this.authService.getUserType().subscribe(type => {this.userType = type; });
  }
  addClient(client: Client) {
    if (this.userType === 'partner') {
      client.creationDate = firebase.database.ServerValue.TIMESTAMP;
      client['owner'] = this.userId;

      const key = this.db.createPushId();
      client.key = key;
      return this.db.object(`clientsPerPartner/${this.userId}/${key}`).update(client);
      // return Observable.fromPromise(this.db.object(`partner/pendences/newClient/${key}/`).set(partner))
      //   .flatMap(resp => this.sdkDb.ref(`admin/pendences/newPartner/${key}/result`).once('child_added').then(snap => snap.val()));
    }
  }
  addClientInfo(clientKey: string, info: ClientInfo) {
    info.partnerId = this.userId;
    info.clientId = clientKey;
    info.creationDate = firebase.database.ServerValue.TIMESTAMP;
    info.order = -moment().valueOf();
    const key = this.db.createPushId();
    info.key = key;
    return this.sdkDb.ref(`clientsInfo/${this.userId}/${clientKey}/${key}`).update(info);
  }
  getAllClients() {
    return this.db.list(`clientsPerPartner/${this.userId}/`).valueChanges();
  }
  getClient(clientKey: string) {
    return this.db.object<Client>(`clientsPerPartner/${this.userId}/${clientKey}`).valueChanges();
  }
  getClientPMI(clientKey: string) {
    return this.db.list(`pmiPerClient/${clientKey}`).valueChanges();
  }
  getClientTrainnings(clientKey: string) {
    return this.db.list(`trainingPerClient/${clientKey}`).valueChanges();
  }
  getClientInfo(clientKey: string) {
    return this.db.list(`clientsInfo/${this.userId}/${clientKey}`, ref => ref.orderByChild('order')).valueChanges();
  }

}



// WEBPACK FOOTER //
// C:/Users/bruna/Desktop/nuresp/src/app/shared/services/client.service.ts